import { ui } from 'angular';

export class MeurhSolicitacoesgenericasModalConfirmService {

    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(entity: any, textos: any): ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./modalsolicitacaogenerica.confirm.html'),
            controller: 'MeurhSolicitacoesgenericasModalConfirmController',
            controllerAs: 'confirm',
            windowClass: '',
            backdrop: 'static',
            resolve: {
                entity: () => entity,
                textos: () => textos,
            }
        });
    }
}
